export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const UPDATE_STATE = 'UPDATE_STATE'
export const LOAD_NOTIFICATION = 'LOAD_NOTIFICATION'
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const USER_LOCATION_CHANGED = 'USER_LOCATION_CHANGED'
export const SET_USER_MENU = 'SET_USER_MENU'
